import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import Button from 'react-bootstrap/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import './blog.css'
import blogService from '../../service/blogService'
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import toast from '../../service/toaster'
import { redirectToLogin } from '../../service/authRedirect';


export default function () {
    const navigate = useNavigate();
    const userDetails = JSON.parse(localStorage.getItem("userDetails"))
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastFetchedPage, setLastFetchedPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const itemsPerPage = 8;
    const fetchedPages = useRef(new Set());
    const initialLoad = useRef(false);

    const updateDeviceMode = useCallback(() => {
        setIsMobile(window.innerWidth <= 768);
    }, []);

    useEffect(() => {
        updateDeviceMode();
        window.addEventListener('resize', updateDeviceMode);
        return () => window.removeEventListener('resize', updateDeviceMode);
    }, [updateDeviceMode]);

    const fetchPage = useCallback(async (pageToFetch) => {
        if (loading) return;
        if (fetchedPages.current.has(pageToFetch)) {
            setCurrentPage(pageToFetch);
            return;
        }
        if (!hasMore && pageToFetch > lastFetchedPage) {
            return;
        }
        setLoading(true);
        try {
            let { data } = await blogService.getBlog(pageToFetch, itemsPerPage);
            data = (data || []).map(ele => ({ ...ele, isReadMore: true }));
            setItems(prev => pageToFetch === 1 ? data : [...prev, ...data]);
            fetchedPages.current.add(pageToFetch);
            setHasMore(data.length >= itemsPerPage);
            setLastFetchedPage(pageToFetch);
            setCurrentPage(pageToFetch);
        }
        catch (err) {
            toast.error("Blog can't be seen!!!");
            redirectToLogin(navigate);
        }
        finally {
            setLoading(false);
        }
    }, [hasMore, itemsPerPage, lastFetchedPage, loading, navigate]);

    useEffect(() => {
        if (initialLoad.current) return;
        initialLoad.current = true;
        fetchPage(1);
    }, [fetchPage]);

    useEffect(() => {
        if (!isMobile) return;
        const handleScroll = () => {
            if (loading || !hasMore) return;
            const reachBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 150;
            if (reachBottom) {
                fetchPage(lastFetchedPage + 1);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [fetchPage, hasMore, isMobile, lastFetchedPage, loading]);

    const visibleItems = isMobile
        ? items
        : items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const likeUnlikeBlog = async (blogId, islike) => {
        try {
            setItems(blogs => blogs.map(blog => {
                if (blog._id === blogId) {
                    let likes = (islike) ? blog.likes.filter((ele) => { return ele != userDetails._id }) : [...blog.likes, userDetails._id]
                    // blog.likes.filter((ele) => { return ele != userDetails._id })
                    console.log(likes);

                    return {
                        ...blog,
                        islike: !blog.islike,
                        likes: likes
                    };
                }

                return blog;
            }))
            if (islike) {
                await blogService.unlikeBlog(blogId);
                toast.success(`You unliked a Blog`);
            }
            else {
                await blogService.likeBlog(blogId);
                toast.success(`You liked a Blog`);
            }
        }
        catch (err) {
            toast.error("Blog can't be liked!!!");
        }
    }

    const viewBlog = async (blogId) => {
        try {
            toast.success("All Blogs Found " + blogId);
            navigate('/blogs/view/' + blogId);
        }
        catch (err) {
            toast.error("Blog can't be seen!!!");
            redirectToLogin(navigate);
        }
    }

    const goToNextPage = async () => {
        const nextPage = currentPage + 1;
        const needMoreData = items.length < nextPage * itemsPerPage;
        if (needMoreData && hasMore) {
            await fetchPage(nextPage);
        } else if (!needMoreData) {
            setCurrentPage(nextPage);
        }
    };

    const goToPrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const totalPages = hasMore
        ? Math.max(1, lastFetchedPage + 1) // if backend says more pages exist, show at least one extra
        : Math.max(1, Math.ceil(items.length / itemsPerPage));
    const canGoNext = hasMore || currentPage < totalPages;

    return (
      <div className="blog-container">
            {/* <div style={{ display: 'flex' }}>
                <h1>Blog Post</h1>
                <Button variant="primary" onClick={() => {
                    navigate("/blogs/add")
                }}>Add Blog</Button>
            </div> */}
            <div className="blog-feed">

                {
                    visibleItems.map(elt => (
                        <Card className="blog-card" key={elt._id}>
                            <CardHeader
                                avatar={
                                    <Avatar sx={{ bgcolor: red[500], position: "inherit" }} aria-label="recipe">
                                        {elt.author.split(" ").map(ele => ele[0]?.toUpperCase())}
                                    </Avatar>
                                }
                                action={
                                    <IconButton aria-label="settings">
                                        <MoreVertIcon />
                                    </IconButton>
                                }
                                title={elt.title}
                                subheader={elt.published_at}
                            />
                            <CardMedia
                                component="img"
                                className="blog-card-media"
                                // image={require("../assets/cricket-player.png")}
                                image={"data:image/jpeg;base64," + elt.images}
                                onClick={() => viewBlog(elt._id)}
                            />
                            <CardContent className='content-container' onClick={() => viewBlog(elt._id)}>
                                <Typography variant="body2" color="text.secondary" dangerouslySetInnerHTML={{ __html: (elt.content.length > 150) ? elt.content.slice(0, 181) : elt.content }}>
                                </Typography>
                                <span>{(elt?.tags.length) ? `\n #${elt.tags[0].split(",").join(" #")}` : ""}</span>
                            </CardContent>
                            <CardActions disableSpacing>
                                <IconButton aria-label="add to favorites" onClick={() => likeUnlikeBlog(elt._id, elt.islike)}>
                                    {elt.islike ? (
                                        <FavoriteIcon style={{ fill: 'red' }} /> // Fill the icon with red color when liked is true
                                    ) : (
                                        <FavoriteBorderIcon />
                                    )
                                    }
                                </IconButton>{elt?.likes?.length || 0} likes
                            </CardActions>
                        </Card>
                    ))
                }
            </div>
            {!isMobile && (
                <div className="pagination-controls">
                    <Button variant="secondary" onClick={goToPrevPage} disabled={currentPage === 1}>
                        Previous
                    </Button>
                    <span className="page-number"> Page {currentPage} of {totalPages} </span>
                    <Button variant="secondary" onClick={goToNextPage} disabled={!canGoNext}>
                        Next
                    </Button>
                </div>
            )}
            <div className="hover-button">
                <Button variant="primary" className="futuristic-button" onClick={() => navigate("/blogs/add")}>
                    <span className="button-icon">+</span>
                    <span className="button-text">Add Blog</span>
                </Button>
            </div>
        </div >
    );
}
